import { mainNavList } from './bleskHeaderCommon';

export const bleskHeaderStore = {
  stickyHeaderState: false,
  secondaryOthersSubitems: [],
  currentNavList: mainNavList,
};
